import { render } from "./InstallVideoModal.vue?vue&type=template&id=4241ce28"
import script from "./InstallVideoModal.vue?vue&type=script&lang=js"
export * from "./InstallVideoModal.vue?vue&type=script&lang=js"
script.render = render

export default script